require('dom-slider')
const { slideDown, slideUp, slideToggle } = window.domSlider

$(() => {
    // Open or close accordion menu
	$('body').on('click', '.accordion .section .section-header', event => {
		var section = $(event.target).closest('.section')
		if (section.hasClass('sliding')) return false
		var body = section.find('.section-body')

		// Close
		if (section.hasClass('active')) {
			section.addClass('sliding').removeClass('active')
			window.domSlider.slideUp({element: body[0], slideSpeed: 400}).then(() => {
				section.removeClass('sliding')
			})
		}

		// Open
		else {
			section.addClass('sliding').addClass('active')
			window.domSlider.slideDown({element: body[0], slideSpeed: 400}).then(() => {
				section.removeClass('sliding')
			})
		}
	})

    // Open or close accordion submenu
	$('body').on('click', '.accordion .section .subsection .subsection-header', event => {
		var section = $(event.target).closest('.subsection')
		if (section.hasClass('sliding')) return false
		var body = section.find('.subsection-body')

		// Close
		if (section.hasClass('active')) {
			section.addClass('sliding').removeClass('active')
			window.domSlider.slideUp({element: body[0], slideSpeed: 400}).then(() => {
				section.removeClass('sliding')
			})
		}

		// Open
		else {
			section.addClass('sliding').addClass('active')
			window.domSlider.slideDown({element: body[0], slideSpeed: 400}).then(() => {
				section.removeClass('sliding')
			})
		}
	})
})